import React from 'react';
import { Download } from 'lucide-react';
import { useTranslation } from "react-i18next";

const DownloadButton = ({ url, filename, className = "", iconSize = 18 }) => {
    const { t } = useTranslation();

    const handleDownload = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!url) return;

      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "document.pdf";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      a.remove();
    };

    return (
        <button
            onClick={handleDownload}
            title={t('EDIT.DOWNLOAD')}
            className="p-2 text-darkGray transition-colors flex items-center justify-center"
        >
            <Download size={iconSize} strokeWidth={2.5} />
        </button>
    );
};

export default DownloadButton;